import HubServices from "../../configuration/config.json"
import Vue from 'vue';
import axios from 'axios';
import Snotify, { SnotifyPosition } from 'vue-snotify'
const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}
Vue.use(Snotify, options)

export default function gettingHttpFunctions() {
  var myObject = new Vue({
    methods: {
      mainAxiosRequest: async function (config) {
        config.axiosConfig.url = HubServices.Authentication_URL + config.axiosConfig.url;
        if (!config.axiosConfig) {
          Vue.prototype.$snotify.warning("Please enter axios config.", {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          });
          return false;
        }
        if (config.axiosConfig.isBarrerNeeded === true) {
          config.axiosConfig.headers = {
            'content-type': 'application/json',
            'Accept': 'application/json',
            "Authorization": "Bearer " + window.localStorage.getItem("access_token")
          };
          console.log(window.localStorage.getItem("access_token"));
        } else if (config.axiosConfig.isBarrerNeeded === false) {
          config.axiosConfig.headers = {
            'content-type': 'application/json',
            'Accept': 'application/json'
          }
        }
        return await axios(config.axiosConfig)
          .then(function (response) {
            if (response.headers !== undefined && response.headers.access_token !== undefined) {
              localStorage.access_token = response.headers.access_token;
            }
            switch (response.status) {
              case 200:
              case 201:
                if (config.showAlert && response.data.message) {
                  // alertify.alert("Success", response.data.message);
                } else {
                  return response.data !== undefined ? response.data : response;
                }
                break;
              default:
                break;
            }
          })
          .catch(function (error) {
            console.log('Error:', error);
            if (error.response) {
              var status = error.response.status;
              var data = error.response.data;
              switch (status) {
                case 400:
                  if (data.message.includes("Access Token Expired") || (data.message == "invalid_grant")) {
                    localStorage.removeItem("embryo");
                    window.location.href = "https://ecom.auth.ap-south-1.amazoncognito.com/login?client_id=6tiuv4k2usal6rgson7mhu8a53&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone&redirect_uri=https://ecomdemo.sgspartnerworld.com?nodeCode=AGY20518";
                  }
                  //  Vue.prototype.$snotify.error(data.message);
                  Vue.prototype.$snotify.error(data.message, {
                    closeOnClick: false,
                    pauseOnHover: false,
                    timeout: 1000,
                  });
                  break;
                case 401:
                case 403:
                case 408:
                  // Vue.$toast.open({ message: cmsHelper.getValidationMsgByCode('M001'),type: 'success',});
                  Vue.prototype.$snotify.error(data.message, {
                    closeOnClick: false,
                    pauseOnHover: false,
                    timeout: 1000,
                  });
                  break;
                case 500:
                  Vue.prototype.$snotify.error(data.message, {
                    closeOnClick: false,
                    pauseOnHover: false,
                    timeout: 1000,
                  });
                  // if (config.showAlert) {
                  // self.$alertify.alert("Warning", data.message || "We have found some technical difficulties. Please contact admin.");
                  // }
                  break;

                default:
                  break
                // if (config.showAlert) {
                //   // self.$alertify.alert("Error", "We have found some technical difficulties. Please contact admin.");
                // }
              }
              console.log(error);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              // alertify.alert("Error", "The request was made but no response was received.");
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              config.errorCallback(error);
              // alertify.alert("Error", error.message);
              console.log('Error', error);
            }
          });
      }
    }
  });
  return myObject;
}